export interface Contact {
  title?: string;
  forename?: string;
  surname?: string;
  person_gid: string;
  person_did?: string;
  mobile_tel?: string;
  home_tel?: string;
  work_tel?: string;
  contact_email?: string;
}

export const Contact = undefined;
